import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const EmptyMeta: ComponentMeta = {
  componentName: "Empty",
  package: "@mijadesign/web",
  title: "空状态",
  description: "数据为空时的占位提示",
  category: ComponentCategory.DATA_DISPLAY,
  icon: "InboxOutlined",
  canHaveChildren: false,
  visibleInComponentPanel: true,
  props: [
    {
      name: "description",
      label: "描述文字",
      type: PropType.STRING,
      group: "基础",
    },
    {
      name: "visible",
      label: "是否显示",
      type: PropType.BOOLEAN,
      bindable: true,
      defaultValue: true,
      group: "状态",
    },
  ],
  defaultProps: {
    description: "暂无数据",
    visible: true,
  },
  preview: [
    {
      title: "默认空状态",
      props: {
        description: "暂无数据",
      },
    },
    {
      title: "业务空状态",
      props: {
        description: "暂无符合条件的页面",
      },
    },
  ],
  docLinks: [
    {
      title: "Empty 文档",
      url: "https://frontend.mishudata.com/uigallery/iframe.html?key=mijadesign-web/components/empty",
      source: "mijadesign",
    },
  ],
  npm: {
    package: "antd",
    exportName: "Empty",
  },
  snippet: {
    componentName: "Empty",
    package: "antd",
    props: {},
  },
};
